import { mockComponent } from 'bloko/common/setupMockComponents';

export default mockComponent('ColumnsWrapper', null, { withChildren: true });
